import type GetSignInBgStyles from './types';

const getSignInBgStyles: GetSignInBgStyles = () => ({});

export default getSignInBgStyles;
